export default __webpack_public_path__ + "static/media/oss-lg.8d5007a5.png";